import { assignmentErrorMessages } from '@repo/lib/messages/assignmentErrorMessages';
import { useQuery } from '@tanstack/react-query';

import { useErrorMessage } from '#error-message/useErrorMessage';

import { AssignmentService } from './assignmentService';
import { AssignmentKey } from './keys';

export function useGetAssignment(id?: number, enabled = true) {
  const getAssignment = useQuery({
    queryKey: [AssignmentKey.ASSIGNMENT, id],
    queryFn: () => AssignmentService.getAssignment(id).then((response) => response.data),
    enabled: id !== undefined && enabled,
  });

  const errorMessage = useErrorMessage(getAssignment.error, assignmentErrorMessages);

  return { ...getAssignment, errorMessage };
}
